$(document).ready(function(){

  
  // General Message
  $('.generalmessage').prependTo('header');

  // homepage / footer tix button url
  $('.custom-tix-btn').attr('href', $('.header .ticket').attr('href'));

  // searchbox text
  $('.header .searchBox .inputFieldTextbox').val('');
  $('.header .searchBox .inputFieldTextbox').attr('placeholder', 'Search');


  // homepage tier 1 content
  $('#siteInfoBannerWidget').prependTo('.tier-one__content');

  // Place Sponsor Logo
  $('.header-right .presented-by').clone().appendTo('.header-left');
  $('.header-right .presented-by').clone().prependTo('.tier-one__content');

  // Subpages - insert siteInfoBanner between header and content
  if (!$('body').hasClass('homepage')) {
    const afterHeader = `
      <div class="afterHeader">
          <a class="presented-by" href="https://www.ford.com/" target="_blank" aria-label="presented by Ford"></a>
      </div>
    `;
    $(afterHeader).insertAfter('.header');
    $('.afterHeader').append($('#siteInfoBannerWidget'));
  }

  // move breadcrumbs below header
  $('#MainContent_content_smp_breadcrumbs').insertAfter('.header');

  // replace breadcrumb > icon
  $('#MainContent_content_smp_breadcrumbs').find('.small.bc').each(function() {
    if ($(this).text().includes('>')) {
      $(this).html(`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z"/></svg>
      `);
    }
  });

  if ($('.dynamicPageContainer').length) {
    $('body').addClass('dynamic-page');
  }

  $('.dynamicPageContainer .sectionHeading').each(function() {
    const text = $(this).text();

    if (text === '{title}') {
      $(this).parent('.entityContainerRow').addClass('ps--centered-title');
    }

    if (text === '{full-image}') {
      $(this).parent('.entityContainerRow').addClass('ps--full-image');
    }

    if (text === '{subheading}') {
      $(this).parent('.entityContainerRow').addClass('ps--subheading');
    }

    if (text === '{full-block}') {
      const section = $(this).parent('.entityContainerRow');
      const tmmHeading = section.find('.moduleTitle').text();
      const img = section.find('.media-container img');
      section.addClass('ps--full-block');
      section.css('background-color', tmmHeading);
      if (img.length) {
        section.css('background-image', `url("${img.attr('data-src')}")`);
      }
    }
  });


  // footer email signup
  const handleEmailSignup = () => {
    const inputVal = $('.ft-email-signup__input').val();
    $('.footer .emailInputField input').attr('value', inputVal);
    $('.footer .emailSubmitButton').click();
  }

  $('.ft-email-signup__submit').on('click keydown', function(event) {
    if (event.type === 'click' || event.key === 'Enter') {
      handleEmailSignup();
    }
  });

  $('.ft-email-signup__input').on('keydown', function(event) {
    if (event.key === 'Enter') {
      handleEmailSignup();
    }
  });


  // add animate.css classes to t3 tix button
  if ($('body').hasClass('homepage')) {
    function t3TixAnim() {
      const target = document.querySelector(`.section-tier-three .custom-tix-btn`);
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.5],
      };
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            $(entry.target).addClass('animate__animated animate__bounceIn');
          }
        });
      };
      let observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    }
    t3TixAnim();
  }


  // append social networks
  const socialNetworks = $('.socialNetworks');
  socialNetworks.find('a, img').removeAttr('id');
  socialNetworks.find('img').each(function() {
    const src = $(this).attr('src');
    $(this).removeAttr('style');
    $(this).attr('src', `${src.split('.png')[0]}.png`);
  });

  socialNetworks.prependTo('.ft-connect__social');
  socialNetworks.clone().prependTo('#nav-menu-panel .nav-menu-panel__social');

});


